import { useEffect } from 'react'
import anchorScrollManager from 'Helpers/anchorScrollManager'

const useAnchorScroll = () => {
    useEffect(() => {
        anchorScrollManager.init()
        return () => {
            anchorScrollManager.destroy()
        }
    }, [])

    return {
        scrollToElementWithAdjustment: anchorScrollManager.scrollToElementWithAdjustment,
        scrollToCurrentHash: anchorScrollManager.scrollToCurrentHash,
        scrollHashWhenAvailable: anchorScrollManager.scrollHashWhenAvailable
    }
}

export default useAnchorScroll